import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'samples-guest_retailer_confirmation_modal_upsell-click';

/**
 * Fired when a logged-out user clicks on the upsell link on the sample request confirmation modal
 */
export function trackSamplesGuestRetailerConfirmationModalUpsellClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
